<template>
    <div class="row">
        <div class="col-sm-6 winning-trophy-container">
            <img class="winning-trophy" src="@img/misc/trophy.png"/>
        </div>
        <div class="col-sm-6">
            <win-point
                    class="row winning-point"
                    v-bind:key="i"
                    v-bind:point="point"
                    v-for="(point, i) in options.points"/>
        </div>
    </div>
</template>
<script>
    import PageComponentTemplate from '../page-component-template';
    import WinPoint from './win-point'

    export default {
        name: 'page-component-win-screen',
        extends: PageComponentTemplate,
        components: {
            WinPoint
        }
    }
</script>
<style lang="less" scoped>
    .winning-trophy-container {
        text-align: right;
    }

    .winning-trophy {
        max-width: 310px;
        padding-right: 50px;
    }
</style>